import { render } from "./Tcle.vue?vue&type=template&id=6438431c&scoped=true"
import script from "./Tcle.vue?vue&type=script&lang=js"
export * from "./Tcle.vue?vue&type=script&lang=js"

import "./Tcle.vue?vue&type=style&index=0&id=6438431c&lang=scss&scoped=true"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6438431c"]])

export default __exports__